import { render, staticRenderFns } from "./alarmTip.vue?vue&type=template&id=3faf2057&lang=true"
import script from "./alarmTip.vue?vue&type=script&lang=js"
export * from "./alarmTip.vue?vue&type=script&lang=js"
import style0 from "./alarmTip.vue?vue&type=style&index=0&id=3faf2057&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports